import { useAppNavigate, buildNavigatePath } from "hooks/useAppNavigate";
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import LoadingButton from "components/LoadingButton";
import ErrorMessage from "components/ErrorMessage";
import PageTitle from "components/PageTitle";
import PageMeta from "components/PageMeta";
import { validateUserCode } from "services/auth.service";
import { useQueryParams } from "hooks/useQueryParams";
import OtpInput from "components/Otp";
import { useLoginPage } from "hooks/useLoginPage";
import { useText } from "context/TextProvider";
import { trackEvent } from "services/analytics.service";
import { AnalyticsEvent, AnalyticsStatus, DeviceGrantStep } from "services/analyticsEvents";
import { useScreenTimeTracking } from "hooks/useScreenTimeTracking";

const DeviceGrantValidateUserCode = (): JSX.Element => {
  const text = useText();
  const appNavigate = useAppNavigate();
  useScreenTimeTracking(AnalyticsEvent.TIME_ON_DEVICE_VALIDATE_USER_CODE_SCREEN);
  const [userCode, setUserCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { loginPageConfig } = useLoginPage();
  const query = useQueryParams();

  useEffect(() => {
    const code = query.get("user_code");
    if (code) setUserCode(code);
  }, [query]);

  const handleValidate = async () => {
    setError("");
    setLoading(true);
    try {
      await validateUserCode({
        user_code: userCode,
        url: loginPageConfig?.urls?.validate_user_code,
      });
      trackEvent(AnalyticsEvent.VALIDATE_USER_CODE_SUCCEEDED, { step: DeviceGrantStep.VALIDATE_USER_CODE, status: AnalyticsStatus.SUCCEEDED });
      if (userCode) {
        sessionStorage.setItem("device_grant_user_code", userCode);
      }
      appNavigate(`/device-grant-flow/home`);
    } catch (err) {
      setError(text.deviceGrant.validateUserCode.invalidCode);
      trackEvent(AnalyticsEvent.VALIDATE_USER_CODE_FAILED, { step: DeviceGrantStep.VALIDATE_USER_CODE, status: AnalyticsStatus.FAILED });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ textAlign: "center" }}>
      <PageMeta name="Device Grant Validate User Code" />
      <PageTitle>{text.deviceGrant.validateUserCode.title}</PageTitle>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <OtpInput otp={userCode} setOtp={setUserCode} acceptText />
      <LoadingButton
        loading={loading}
        onClick={handleValidate}
        sx={{ width: "100%", height: "3.5rem", mb: "1rem" }}
      >
        {text.deviceGrant.validateUserCode.nextButton}
      </LoadingButton>
      {/* <LoadingButton
        onClick={() => {
          window.location.href = `tbn-app://open?type=connect`;
        }}
        sx={{ width: "100%", height: "3.5rem" }}
      >
        {text.deviceGrant.validateUserCode.loginWithAppButton}
      </LoadingButton> */}
    </Box>
  );
};

export default DeviceGrantValidateUserCode;
